export const awayFirstSports = (sport: string): boolean =>
  ["American Football", "Basketball", "Baseball", "Ice Hockey"].includes(sport);

export function orderedCompetitorData<T>(
  data: { home: T; draw?: T; away: T },
  sport: string
): T[] {
  const dataArray: T[] = [];

  dataArray[0] = !awayFirstSports(sport) ? data.home : data.away;
  dataArray[1] = !awayFirstSports(sport) ? data.away : data.home;

  if (data.draw) {
    dataArray.splice(1, 0, data.home);
  }

  return dataArray;
}
